import Emitter from "es6-event-emitter";
import {
  CLICKED_BACK_IFRAME,
  CLICKED_CLOSE_IFRAME,
  OPENED_IFRAME_SETTINGS,
} from "./../../analytics/analyticsevents";
import settingIframe from "./../../templates/settings/settingIframe.dust";

export default class SettingIFrame extends Emitter {
  _appState = null;
  DOMContainer = null;
  name = null;
  title = null;
  url = null;

  constructor(appState, container, name, title, url, options = null) {
    super();
    this._appState = appState;
    this.DOMContainer = container;
    this.name = name;
    this.title = title;
    this._options = options;
    this.url = url;
    this.render();
  }

  render() {
    const context = {};
    context.back = true;
    context.close = true;

    context.name = this.name;
    context.title = this.title;

    //render layout with context
    if (this.DOMContainer !== null) {
      Dust.render(settingIframe, context, (err, result) => {
        this.DOMContainer.innerHTML = result;

        this.attachClickHandlers();

        this.show();
      });
    }
  }

  attachClickHandlers() {
    const backButton = this.DOMContainer.querySelector(
      ".overlay-navigation-back .overlay-navigation-icon"
    );
    if (backButton) {
      backButton.addEventListener("click", (e) => {
        this.onBackButtonClick(e);
      });
    }

    const closeButton = this.DOMContainer.querySelector(
      ".overlay-navigation-close .overlay-navigation-icon"
    );
    if (closeButton) {
      closeButton.addEventListener("click", (e) => {
        this.onCloseButtonClick(e);
      });
    }
  }

  onBackButtonClick(e) {
    e.stopPropagation();
    this.hide();
    this._appState.triggerEvent(CLICKED_BACK_IFRAME);
  }

  onCloseButtonClick(e) {
    e.stopPropagation();
    this.close();
    this._appState.triggerEvent(CLICKED_CLOSE_IFRAME);
  }

  close() {
    if (this.DOMContainer !== null) {
      this.DOMContainer.classList.add("hidden");
    }
    this.trigger("settingIframe:closed");
  }

  hide() {
    if (this.DOMContainer !== null) {
      this.DOMContainer.classList.add("hidden");
    }
  }

  isEmpty() {
    return this.DOMContainer.innerHTML === "";
  }

  show() {
    if (this.DOMContainer !== null) {
      const iframe = this.DOMContainer.querySelector("iframe");
      if (iframe) {
        iframe.src = this.url;
      }
      this.DOMContainer.classList.remove("hidden");
      this._appState.triggerEvent(OPENED_IFRAME_SETTINGS);
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/settings/settingIFrame.js